// src/core/adapters/LondonDataSort.js
//
// London stop ordering. Pattern-first, sequence-second.
// compareStops is exported so callers can invert direction for lane ordering.

export const compareStops = (a, b) => {
  const patternA = Number(a.pattern_idx);
  const patternB = Number(b.pattern_idx);
  if (patternA !== patternB) return patternA - patternB;
  return (a.sequence_no ?? 0) - (b.sequence_no ?? 0);
};

export const sortStops = (stops) => [...stops].sort(compareStops);